export const appConstants = {
    LOADING: 'LOADING_APP',
    ERROR: 'ERROR_APP',
    ACTIVE_STAGE: 'ACTIVE_STAGE_APP',
    REGISTRATION_STAGE: 'REGISTRATION_STAGE_APP',
    GET_TERMS_CONDITIONS: 'GET_TERMS_CONDITIONS_APP',
    ACCEPT_TERMS_AND_CONDITIONS: 'ACCEPT_TERMS_AND_CONDITIONS_APP',
}